// extracted by mini-css-extract-plugin
export default {"section-title":"FormSection_section-title__YQxRq","container":"FormSection_container__zol4H","legend":"FormSection_legend__y2G08"};